import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import authorizationsSlice from '../reducers/authorizations.slice'

const persistConfig = {
  key: 'authorizationsSlice',
  storage,
}

export const persistedAuthorizationsReducer = persistReducer(persistConfig, authorizationsSlice)